import { ApiService } from "Services/ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export interface ActiveLanguage {
  id: number;
  language: string;
  isActive: string;
}

export const activeLanguageApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllActiveLanguages: builder.query<ActiveLanguage[], void>({
      query: () => ({
        url: "language/active-language",
        method: "GET",
      }),
      transformResponse: (res: ResultsDTO<ActiveLanguage[]>) => res.results ?? [],
      providesTags: [{ type: "Language", id: "ACTIVE_LIST" }],
    }),
    getActiveLanguagesByProductType: builder.query<ActiveLanguage[], string>({
      query: (productType) => ({
        url: "language/active-languages-by-product-type",
        method: "GET",
        params: { productType },
      }),
      transformResponse: (res: ResultsDTO<ActiveLanguage[]>) => res.results ?? [],
      providesTags: (result, error, productType) => [
        { type: "Language", id: `ACTIVE_LIST_${productType}` },
      ],
    }),
  }),
});

export const {
  useGetAllActiveLanguagesQuery,
  useGetActiveLanguagesByProductTypeQuery,
} = activeLanguageApiSlice;
